import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AutoLogout from "./LogoutTimeOut/AutoLogout";
import DocumentViewer from "./components/ui/DocumentViewer";
import { installApiInterceptors } from "./auth/http";

// Every call to our API carries the access token, and a 401 ends the session.
installApiInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Toaster position="bottom-right" />
    <DocumentViewer />
    <BrowserRouter>
      <AutoLogout>
        <App />
      </AutoLogout>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
